import curry from "../../../lib/core/functional/curry";

const renderModule = curry(function renderModule(preact, _context, { Notification }, _altLoader) {
    const { hooks, h } = preact;
    const { useCallback, useState, useEffect, useRef } = hooks;

    function renderNotification(notification) {
        return <Notification key={notification.id} {...notification} />;
    }

    function Module({
        count,
        picture,
        username,
        notifications,
        markAllAsRead,
        beforeLinks,
        afterLinks,
    }) {
        const [display, setDisplay] = useState(false);
        const [disappear, setDisappear] = useState(false);
        const userInfoMenu = useRef(null);
        const elementsBefore = beforeLinks || null;
        const elementsAfter = afterLinks || null;

        useEffect(() => {
            if (!disappear) {
                return;
            }

            const timeoutId = setTimeout(() => {
                setDisappear(false);
                setDisplay(false);
            }, 300);

            return () => {
                clearTimeout(timeoutId);
            };
        }, [disappear]);

        useEffect(() => {
            if (display && userInfoMenu.current) {
                userInfoMenu.current.focus();
            }
        }, [display, userInfoMenu]);

        const toggleDisplay = useCallback(() => {
            setDisplay(!display);
        }, [display]);

        const closeNotification = useCallback(() => {
            if (display) {
                setDisappear(true);
            }
        }, [display]);

        const textualCount = count <= 9 ? count : "+9";

        return (
            <div class="rebel-user-info">
                <div
                    class={`rebelbar__user-info clearfix${
                        display ? " user-info__menu--active" : ""
                    }`}
                >
                    <div
                        tabindex="0"
                        class="user-info__menu"
                        ref={userInfoMenu}
                        onBlur={closeNotification}
                    >
                        <div id="user_name">{username}</div>
                        <button
                            onClick={toggleDisplay}
                            class="user-info__menu-label user-info__menu-label--no-arrow user-info__menu-label--logged-in image js--userdata-thumb js--toggle-user-info__menu"
                            style={`background-image: url(${picture});`}
                        ></button>
                        <span class={`notification-counter${count == 0 ? " hidden" : ""}`}>
                            {textualCount}
                        </span>

                        <div class="user-info__dropdown-wrapper">
                            {elementsBefore}
                            <span class={`notification-counter${count == 0 ? " hidden" : ""}`}>
                                {textualCount}
                            </span>
                            <ul class="user-info__dropdown">
                                {count > 0 && (
                                    <li class="mark-all-as-read" onClick={markAllAsRead}>
                                        mark all as read
                                    </li>
                                )}
                                {notifications.map(renderNotification)}
                            </ul>
                            {elementsAfter}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return Module;
});

export default function riverTopBar({ preact }) {
    return renderModule(preact);
}
